export default "__VITE_ASSET__BMCrUaxM__"